import React, { useState } from 'react';

import { APIROOT } from '../../Helpers/configs';
import { GetAuth } from '../../Auth/AuthProvider';

import Card from '@mui/material/Card';
import { Modal, Button, Box } from '@mui/material';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
// import { useNavigate } from 'react-router-dom';

// function createData(serialId, tickeNumber, date, technician, description) {
//   return { serialId, tickeNumber, date, technician, description };
// }

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  borderRadius: 2,
  p: '1px 1px 1px  10px ',
};
const style2 = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  borderRadius: 2,
  p: '1px 1px 1px  1px ',
};

const statusColor = (status) => {
  
  let color;

  switch(status.toLowerCase()){ 
    case 'assigned': 
    case 'completed':
    case 'declined':
    case 'logged':
    case 'pending auth':
    case 'query':
    case 're-submit':
    case 'ready to approve': color = 'green';
          break;
    case 'ready to invoice':
    case 'invoiced':
    case 'submitted': color = 'blue';
          break;
    default: color = '';
          break; 
  }

  return color;
}

function TicketByTypeList(props) {
  const ticketData = props.ticketData;
  const type = props.type;

  console.log(ticketData);

  return (
    <Card style={{ margin: '15px 0', padding: 0 }}>
      <Grid
        container
        rowSpacing={0}
        columnSpacing={{ xs: 1, sm: 1, md: 1 }}
        style={{
          // background: '#84a1bc91',
          background: 'rgb(235, 237, 248)',
          height: 'auto',
          // borderRadius: 15,
          //   padding: '5px 10px 5px 20px',
        }}
      >
        <Grid item xs={12} md={12}>
          <Typography variant='h5'>{`${type} Tickets`}</Typography>
        </Grid>

        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} size='small' aria-label='a dense table'>
            <TableHead>
              <TableRow>
                <TableCell
                  style={{
                    background: '#354775',
                    color: '#fff',
                    border: '1 solid ',
                    fontWeight: 'bold',
                  }}
                >
                  Status
                </TableCell>
                <TableCell
                  style={{
                    background: '#354775',
                    color: '#fff',
                    border: '1 solid ',
                    fontWeight: 'bold',
                  }}
                  align='left'
                >
                  Count
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {ticketData.map((row) => (
                <TableRow
                //   key={row.id}
                >
                  <TableCell align='left'>{row.status}</TableCell>
                  <TableCell align='left' sx={{color: statusColor(row.status), fontWeight: 'bold'}}>{row.count}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Card>
  );
}


export default TicketByTypeList;



/**
 * 
 * Green: Assigned, Completed, Declined, Logged, Pending Auth, Query, re-Submit, ready to approve
* Blue: Ready to invoice, invoiced, submitted
 */
